import { Controller } from '@hotwired/stimulus'
import { on, off } from '../lib/events'

export default class extends Controller {
  static values = {
    maxWidth: { type: Number, default: 1280 },
    columns: { type: Number, default: 2 },
    redoTimes: { type: Number, default: 5 },
  }

  connect = () => {
    // this.maxWidthValue = this.element.offsetWidth

    on('resize', this.regenerateMasonry)
    on('generateMasonry', this.generateMasonry)
    setTimeout(() => { this.generateMasonry() }, 200)
    setTimeout(() => { this.generateMasonry() }, 1000)
  }

  disconnect = () => {
    off('generateMasonry', this.generateMasonry)
  }

  generateMasonry = () => {
    // to accomodate safari
    // it seems the major crux of safari's issues
    // are the inability to handle height: 100%
    this.columnInfo = this.setColumnInfo()
    this.originalSize = this.currentSize

    if (this.canBeMasonized) {
      try {
        this.setNodes()
        this.setContainerStyles()
      }
      catch {
        this.redoGenerateMasonry()
      }
    }
  }

  redoGenerateMasonry = () => {
    // accomodate safari loading badly
    if (this.redoTimesValue > 0) {
      this.redoTimesValue -= 1
      setTimeout(() => { this.generateMasonry() }, 200)
    }
  }

  regenerateMasonry = () => {
    if (this.originalSize !== this.currentSize) {
      window.requestAnimationFrame(this.generateMasonry)
    }
  }

  setColumnInfo = () => {
    return Array.from(Array(this.currentSize.columns), (_, i) => {
      return { height: 0, column: i }
    })
  }

  setNodes = () => {
    this.allNodes.forEach((element) => {
      const elementColumnInfo = this.columnInfo.shift()
      this.setWrapperSize(element)

      let { height, column } = elementColumnInfo

      this.setElementStyles(element)

      const nodeTop = `${height}px`
      const nodeLeft = `${(column * this.nodeWidth) + (column * this.currentSize.gap)}px`

      element.style.top = nodeTop
      element.style.left = nodeLeft

      const nodeHeight = element.clientHeight

      if (this.nodeWidth && nodeHeight) {
        elementColumnInfo.height = height += nodeHeight + this.currentSize.gap
        this.columnInfo.push(elementColumnInfo)
      }
    })
  }

  setContainerStyles = () => {
    this.element.style.position = 'relative'
    this.element.style.width = `${this.currentSize.columns * this.nodeWidth + (this.currentSize.columns - 1) * this.currentSize.gap}px`
    const height = Math.max(...this.columnInfo.map(col => col.height), 0)
    this.element.style.height = `${height}px`
  }

  setElementStyles = (element) => {
    element.style.position = 'absolute'
    element.style.padding = '0'
    element.style.transitionProperty = 'top'
    element.style.transitionTimingFunction = 'cubic-bezier(0.175, 0.885, 0.32, 1.275)'
    element.style.transitionDuration = '300ms'
  }

  setWrapperSize = (ele) => {
    if (ele.children[0]) {
      ele.style.width = `${this.nodeWidth}px`
      ele.style.height = `${ele.children[0].offsetHeight}px`
    }
  }

  get allNodes() {
    return Array.from(this.element.children)
  }

  get nodeWidth() {
    const { columns, gap } = this.currentSize
    const minWidth = Math.min(window.innerWidth, this.maxWidthValue) - (gap * 2)

    return (minWidth - (columns * gap)) / this.currentSize.columns
  }

  get canBeMasonized() {
    return this.currentSize.columns && (this.currentSize.columns <= this.allNodes.length)
  }

  get sizes() {
    return [
      { minWidth: 0, columns: 1, gap: 10 },
      { minWidth: 375, columns: this.columnsValue, gap: 15 },
      { minWidth: 768, columns: 3, gap: 25 },
    ]
  }

  get currentSize() {
    const matching = this.sizes.filter(size => window.matchMedia(`(min-width: ${size.minWidth}px)`).matches)

    return matching.reduce((prev, current) => (prev.minWidth > current.minWidth) ? prev : current)
  }
}
